import { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import BackButton from "../../../BackButton/BackButton";
import ConfirmPopup from "./ConfirmPopup";
import { ContentScoreHeaderStyle } from "./css";

function ContentScoreHeader({ selectedRows, onClickHandler, loading }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <ContentScoreHeaderStyle>
      <Box className="ContentWrapper">
        <Typography component="h2">Content editor</Typography>
        <Box className="BtnWrapper">
          <BackButton sx={{ "& button": { marginBottom: "0 !important" } }} />
          <Button className="NextBtn" onClick={() => onClickHandler()} disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "Next"}
          </Button>
        </Box>
      </Box>
      <ConfirmPopup open={open} handleClose={handleClose} />
    </ContentScoreHeaderStyle>
  );
}

export default ContentScoreHeader;
